export default(key, lang) => {
  let mapping = {
    'At least 3 of the following:': {
      en_US: 'At least 3 of the following:',
      de_DE: 'Mindestens 3 der folgenden Punkte:',
      el_GR: 'Τουλάχιστον 3 από τα ακόλουθα:',
      es_ES: 'Al menos 3 de los siguientes:',
      fr_FR: 'Au moins 3 des éléments suivants :',
      fr_CA: 'Au moins 3 des éléments suivants :',
      it_IT: 'Almeno 3 dei seguenti elementi:',
      pl_PL: 'Co najmniej 3 z następujących elementów:',
      th_TH: 'อย่างน้อย 3 ของดังต่อไปนี้:',
      zH_CN: '至少以下 3 項:',
      pt_BR: 'Pelo menos 3 dos seguintes:',
      ja_JP: '次のうち少なくとも 3 つ:',
    },
    'At least 8 characters long': {
      en_US: 'At least 8 characters long',
      de_DE: 'Mindestens 8 Zeichen lang',
      el_GR: 'Τουλάχιστον 8 χαρακτήρες μήκος',
      es_ES: 'Al menos 8 caracteres de largo',
      fr_FR: 'Au moins 8 caractères de long',
      fr_CA: 'Au moins 8 caractères de long',
      it_IT: 'Lunghezza di almeno 8 caratteri',
      pl_PL: 'Co najmniej 8 znaków',
      th_TH: 'มีความยาวอย่างน้อย 8 ตัวอักษร',
      zH_CN: '至少 8 個字元長',
      pt_BR: 'Pelo menos 8 caracteres de comprimento',
      ja_JP: '8 文字以上の長さ',
    },
    'confirm': {
      en_US: 'Confirm',
      de_DE: 'Bestätigen',
      el_GR: 'Επιβεβαιώσετε',
      es_ES: 'Confirmar',
      fr_FR: 'Confirmer',
      fr_CA: 'Confirmer',
      it_IT: 'Confermare',
      pl_PL: 'Potwierdzić',
      th_TH: 'ยืนยัน',
      zH_CN: '確認',
      pt_BR: 'Confirmar',
      ja_JP: '確認',
    },
    'confirmPassword': {
      en_US: 'Confirm Password',
      de_DE: 'Kennwörter stimmen nicht überein',
      el_GR: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
      es_ES: 'Las contraseñas no coinciden',
      fr_FR: 'Les mots de passe ne correspondent pas',
      fr_CA: 'Les mots de passe ne correspondent pas',
      it_IT: 'Le password non corrispondono',
      pl_PL: 'Hasła nie są zgodne',
      th_TH: 'รหัสผ่านไม่ตรงกัน',
      zH_CN: '密碼不匹配',
      pt_BR: 'Senhas não correspondem',
      ja_JP: 'パスワードが一致しません',
    },
    'confirmPasswordRequired': {
      en_US: 'Confirm Password is required.',
      de_DE: 'Bestätigen Sie das Kennwort.',
      el_GR: 'Επιβεβαίωση κωδικού πρόσβασης απαιτείται.',
      es_ES: 'Se requiere Confirmar contraseña.',
      fr_FR: 'Confirmer mot de passe est nécessaire.',
      fr_CA: 'Confirmer mot de passe est nécessaire.',
      it_IT: 'Conferma password è obbligatorio.',
      pl_PL: 'Conferma password è obbligatorio.',
      th_TH: 'ต้องยืนยันรหัสผ่าน',
      zH_CN: '需要確認密碼。',
      pt_BR: 'Confirmar senha é necessário.',
      ja_JP: 'パスワードの確認が必要です。',
    },
    'currentPassword': {
      en_US: 'Current Password',
      de_DE: 'Aktuelles Passwort',
      el_GR: 'Τρέχων κωδικός πρόσβασης',
      es_ES: 'Contraseña actual',
      fr_FR: 'Mot de passe actuel',
      fr_CA: 'Mot de passe actuel',
      it_IT: 'Password corrente',
      pl_PL: 'Bieżące hasło',
      th_TH: 'รหัสผ่านปัจจุบัน',
      zH_CN: '目前密碼',
      pt_BR: 'Senha atual',
      ja_JP: '現在のパスワード',
    },
    'currentPasswordRequired': {
      en_US: 'Current Password is required.',
      de_DE: 'Das aktuelle Kennwort ist erforderlich.',
      el_GR: 'Απαιτείται τρέχων κωδικός πρόσβασης.',
      es_ES: 'Se requiere la contraseña actual.',
      fr_FR: 'Mot de passe actuel est requis.',
      fr_CA: 'Mot de passe actuel est requis.',
      it_IT: 'È richiesta la password corrente.',
      pl_PL: 'Wymagane jest bieżące hasło.',
      th_TH: 'รหัสผ่านปัจจุบันเป็นสิ่งจําเป็น',
      zH_CN: '當前密碼是必需的。',
      pt_BR: 'Wymagane jest bieżące hasło.',
      ja_JP: '現在のパスワードが必要です。',
    },
    'currentPasswordIncorrect': {
      en_US: 'Your current password is incorrect.',
      de_DE: 'Ihr aktuelles Kennwort ist falsch.',
      el_GR: 'Ο τρέχων κωδικός πρόσβασής σας δεν είναι σωστός.',
      es_ES: 'Su contraseña actual es incorrecta.',
      fr_FR: 'Votre mot de passe actuel est incorrect.',
      fr_CA: 'Votre mot de passe actuel est incorrect.',
      it_IT: 'La password corrente non è corretta.',
      pl_PL: 'Twoje aktualne hasło jest nieprawidłowe.',
      th_TH: 'รหัสผ่านปัจจุบันของคุณไม่ถูกต้อง',
      zH_CN: '您目前的密碼不正確。',
      pt_BR: 'Sua senha atual está incorreta.',
      ja_JP: '現在のパスワードが正しくありません。',
    },
    'Good': {
      en_US: 'Good',
      de_DE: 'gut',
      el_GR: 'Καλό',
      es_ES: 'bien',
      fr_FR: 'Bon',
      fr_CA: 'Bon',
      it_IT: 'Buono',
      pl_PL: 'Dobry',
      th_TH: 'ดี',
      zH_CN: '好',
      pt_BR: 'Bom',
      ja_JP: 'よし',
    },
    'newPassword': {
      en_US: 'New Password',
      de_DE: 'Neues Passwort',
      el_GR: 'Νέος κωδικός πρόσβασης',
      es_ES: 'Nueva contraseña',
      fr_FR: 'Nouveau mot de passe',
      fr_CA: 'Nouveau mot de passe',
      it_IT: 'Nuova password',
      pl_PL: 'Nowe hasło',
      th_TH: 'รหัสผ่านใหม่',
      zH_CN: '新密碼',
      pt_BR: 'Nova Senha',
      ja_JP: '新しいパスワード',
    },
    'newPasswordRequired': {
      en_US: 'New Password is required.',
      de_DE: 'Neues Passwort ist erforderlich.',
      el_GR: 'Απαιτείται νέος κωδικός πρόσβασης.',
      es_ES: 'Se requiere una nueva contraseña.',
      fr_FR: 'Un nouveau mot de passe est nécessaire.',
      fr_CA: 'Un nouveau mot de passe est nécessaire.',
      it_IT: 'È necessaria una nuova password.',
      pl_PL: 'Wymagane jest nowe hasło.',
      th_TH: 'รหัสผ่านใหม่เป็นสิ่งจําเป็น',
      zH_CN: '需要新密碼。',
      pt_BR: 'Nova senha é necessária.',
      ja_JP: '新しいパスワードが必要です。',
    },
    'one non-alphanumeric (!, $, #, %, space, etc)': {
      en_US: 'one non-alphanumeric (!, $, #, %, space, etc)',
      de_DE: 'eine nicht alphanumerische Zahl (!, $, #,%, Leerzeichen usw.)',
      el_GR: ' ένα μη αλφαριθμητικό (!, $, #,%, space κ.λπ.)',
      es_ES: 'Uno no alfanumérico (!, $, #,%, espacio, etc.)',
      fr_FR: 'un non alphanumérique (!, $, #,%, espace, etc.)',
      fr_CA: 'un non alphanumérique (!, $, #,%, espace, etc.)',
      it_IT: 'un non alfanumerico (!, $, #,%, spazio, ecc.)',
      pl_PL: 'jeden niealfanumeryczny (!, $, #,%, spacja itp.)',
      th_TH: 'ตัวอักษรและตัวเลขที่ไม่ใช่ตัวอักษร (!, $, #,%, space, etc)',
      zH_CN: '一個非字母數字（！，$，＃，％，空格等）',
      pt_BR: 'um não alfanumérico (!, $, #,%, espaço etc.)',
      ja_JP: '1つの非英数字（！、$、＃、％、スペースなど）',
    },
    'one number': {
      en_US: 'one number',
      de_DE: 'eine Zahl',
      el_GR: 'ένας αριθμός',
      es_ES: 'un número',
      fr_FR: 'un numéro',
      fr_CA: 'un numéro',
      it_IT: 'un numero',
      pl_PL: 'jeden numer',
      th_TH: 'หนึ่งหมายเลข',
      zH_CN: '一個數字',
      pt_BR: 'um número',
      ja_JP: '1つの数字',
    },
    'one lowercase letter': {
      en_US: 'one lowercase letter',
      de_DE: 'ein Kleinbuchstabe',
      el_GR: 'ένα πεζό γράμμα',
      es_ES: 'una letra minúscula',
      fr_FR: 'une lettre minuscule',
      fr_CA: 'une lettre minuscule',
      it_IT: 'una lettera minuscola',
      pl_PL: 'jedna mała litera',
      th_TH: 'ตัวพิมพ์เล็กหนึ่งตัว',
      zH_CN: '一個小寫字母',
      pt_BR: 'uma letra minúscula',
      ja_JP: '1 つの小文字',
    },
    'one uppercase letter': {
      en_US: 'one uppercase letter',
      de_DE: 'ein Großbuchstaben',
      el_GR: 'ένα κεφαλαίο γράμμα',
      es_ES: 'una letra mayúscula',
      fr_FR: 'une lettre uppercase',
      fr_CA: 'une lettre uppercase',
      it_IT: 'una lettera maiuscola',
      pl_PL: 'jedna wielka litera',
      th_TH: 'อักษรตัวพิมพ์ใหญ่หนึ่งตัว',
      zH_CN: '一個大寫字母',
      pt_BR: 'uma letra maiúscula',
      ja_JP: '1 つの大文字',
    },
    'password': {
      en_US: 'Password',
      de_DE: 'Passwort',
      el_GR: 'Κωδικό πρόσβασης',
      es_ES: 'Contraseña',
      fr_FR: 'mot de passe',
      fr_CA: 'mot de passe',
      it_IT: 'Password',
      pl_PL: 'Hasło',
      th_TH: 'รหัส ผ่าน',
      zH_CN: '密碼',
      pt_BR: 'Senha',
      ja_JP: 'パスワード',
    },
    'passwordDoesNotMeetRequirements': {
      en_US: 'Password does not meet requirements',
      de_DE: 'Kennwort entspricht nicht den Anforderungen',
      el_GR: 'Ο κωδικός πρόσβασης δεν πληροί τις απαιτήσεις',
      es_ES: 'La contraseña no cumple con los requisitos',
      fr_FR: 'Mot de passe ne répond pas aux exigences',
      fr_CA: 'Mot de passe ne répond pas aux exigences',
      it_IT: 'La password non soddisfa i requisiti',
      pl_PL: 'Hasło nie spełnia wymagań',
      th_TH: 'รหัสผ่านไม่ตรงตามข้อกําหนด',
      zH_CN: '密碼不符合要求',
      pt_BR: 'A senha não atende aos requisitos',
      ja_JP: 'パスワードが要件を満たしていません',
    },
    'passwordsDoNotMatch': {
      en_US: 'Passwords do not match',
      de_DE: 'Kennwörter stimmen nicht überein',
      el_GR: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
      es_ES: 'Las contraseñas no coinciden',
      fr_FR: 'Les mots de passe ne correspondent pas',
      fr_CA: 'Les mots de passe ne correspondent pas',
      it_IT: 'Le password non corrispondono',
      pl_PL: 'Hasła nie są zgodne',
      th_TH: 'รหัสผ่านไม่ตรงกัน',
      zH_CN: '密碼不匹配',
      pt_BR: 'Senhas não correspondem',
      ja_JP: 'パスワードが一致しません',
    },
    'passwordStrength': {
      en_US: 'Password Strength',
      de_DE: 'Passwortstärke',
      el_GR: 'Δύναμη κωδικού πρόσβασης',
      es_ES: 'Fuerza de contraseña',
      fr_FR: 'Force de mot de passe',
      fr_CA: 'Force de mot de passe',
      it_IT: 'Forza password',
      pl_PL: 'Siła hasła',
      th_TH: 'ความแรงของรหัสผ่าน',
      zH_CN: '密碼強度',
      pt_BR: 'Força de senha',
      ja_JP: 'パスワードの強度',
    },
    'requirements': {
      en_US: 'Requirements',
      de_DE: 'Anforderungen',
      el_GR: 'Απαιτήσεις',
      es_ES: 'Requisitos',
      fr_FR: 'Exigences',
      fr_CA: 'Exigences',
      it_IT: 'Requisiti',
      pl_PL: 'Wymagania',
      th_TH: 'ข้อกําหนด',
      zH_CN: '要求',
      pt_BR: 'Requisitos',
      ja_JP: '要件',
    },
    'Strong': {
      en_US: 'Strong',
      de_DE: 'Stark',
      el_GR: 'Ισχυρή',
      es_ES: 'Fuerte',
      fr_FR: 'Forte',
      fr_CA: 'Forte',
      it_IT: 'Forte',
      pl_PL: 'Silne',
      th_TH: 'แข็ง แกร่ง',
      zH_CN: '強',
      pt_BR: 'Forte',
      ja_JP: '強い',
    },
    'tip': {
      en_US: 'tip: longer passwords are harder to guess',
      de_DE: 'Tipp: Längere Passwörter sind schwerer zu erraten',
      el_GR: 'συμβουλή: πλέον κωδικούς πρόσβασης είναι πιο δύσκολο να μαντέψει',
      es_ES: 'consejo: las contraseñas más largas son más difíciles de adivinar',
      fr_FR: 'Conseil : les mots de passe plus longs sont plus difficiles à deviner',
      fr_CA: 'Conseil : les mots de passe plus longs sont plus difficiles à deviner',
      it_IT: 'suggerimento: le password più lunghe sono più difficili da indovinare',
      pl_PL: 'wskazówka: dłuższe hasła są trudniejsze do odgadnięcia',
      th_TH: 'เคล็ดลับ: รหัสผ่านที่ยาวกว่าจะคาดเดายากขึ้น',
      zH_CN: '提示:較長的密碼更難猜測',
      pt_BR: 'dica: senhas mais longas são mais difíceis de adivinhar',
      ja_JP: 'ヒント: 長いパスワードは推測するのが難しい',
    },
    'Weak': {
      en_US: 'Weak',
      de_DE: 'Schwach',
      el_GR: 'Αδύναμη',
      es_ES: 'Débil',
      fr_FR: 'Faible',
      fr_CA: 'Faible',
      it_IT: 'Debole',
      pl_PL: 'Słabe',
      th_TH: 'อ่อนแอ',
      zH_CN: '弱',
      pt_BR: 'Fraco',
      ja_JP: '弱い',
    },
  };

  return mapping[key][lang];
};
